import template from './linked-accounts.html';
import controller from './linked-accounts.controller';
import './linked-accounts.scss';

const linkedAccountsComponent = {
  require: {
    settingsCtrl: '^settings'
  },
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$rootScope', '$uibModal', '$timeout', '$state', 'settingsService', 'request', 'utils', 'permissions'];

export default linkedAccountsComponent;
